// extracted by mini-css-extract-plugin
export var titleBanner = "title-banner-module--titleBanner--bc752";
export var titleBannerBox = "title-banner-module--titleBannerBox--25311";